var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex" }, [
    _c(
      "div",
      { staticClass: "top-left-btn" },
      [
        _c(
          "el-row",
          { staticClass: "mb8", attrs: { gutter: 10 } },
          [_vm._t("tableOperation")],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "top-right-btn" },
      [
        _c(
          "el-row",
          [
            _c(
              "el-tooltip",
              {
                staticClass: "item",
                attrs: {
                  effect: "dark",
                  content: _vm.vm.$t("settingText"),
                  placement: "top",
                },
              },
              [
                _c("el-button", {
                  attrs: { circle: "", icon: "el-icon-setting" },
                  on: {
                    click: function ($event) {
                      return _vm.showSetting()
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }